import { useCopilotAction } from '@copilotkit/react-core'

import { F0MessageCreditsWarning } from '@factorialco/f0-react'

/**
 * Renders an AI credits warning card with an optional action URL when the
 * company is running low on credits.
 */
export const useMessageCreditsWarningAction = () => {
  useCopilotAction({
    name: 'AiWidgets.UpsellKit.F0MessageCreditsWarning',
    description:
      'Display a warning card when the company has no AI credits left, with a call to action to get more credits.',
    parameters: [
      {
        name: 'actionHref',
        type: 'string',
        description: 'Optional URL opened when the action button is clicked',
        required: false,
      },
    ],
    available: 'frontend',
    render: ({ args: { actionHref } }) => <F0MessageCreditsWarning actionHref={actionHref} />,
  })
}
